import React, {Component} from 'react';
import {
    BrowserRouter as Router,
    Route

} from 'react-router-dom'

import Header from './Header'
import MainEntries from './components/MainEntries'
import BrespaEntries from './components/BrespaEntries'
import Betonentries from './components/Betonentries'
import HFentries from './components/HFentries'
import Startscreen from './components/Startscreen'

//styles
import  'bootstrap/dist/css/bootstrap.css';

import './App.scss';
import './index.css';
import Utils from './utils/Utils'
import {inject} from 'mobx-react';


@inject('baseDataStore')
class App extends Component {
    componentDidMount(){
        setTimeout(()=>{Utils.regde(); this.props.baseDataStore.fetchData();},500)

    }


    render() {
        return (
            <Router>
              <div>
                <Header baseDataStore={this.props.baseDataStore}/>
                <div className="App-main container">


                  <Route exact path="/" component={MainEntries} />
                  <Route exact path={`/${Utils.serverpath}`} component={MainEntries}/>
                  {/*<Route path={`/${Utils.serverpath}/entry`} component={MainEntries}/>*/}
                    <Route path={`/${Utils.serverpath}/brespa`} component={BrespaEntries}/>
                    <Route path={`/${Utils.serverpath}/hf`} component={HFentries}/>
                    <Route path={`/${Utils.serverpath}/beton`} component={Betonentries}/>


                </div>
              </div>
            </Router>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js